<template>
  <div>
    <grant-sub-wizard>
      <grant-sub-wizard-tab>
        <page1></page1>
      </grant-sub-wizard-tab>
    </grant-sub-wizard>
  </div>
</template>

<script>
  import Page1 from './Page1';
  import {GrantSubWizard, GrantSubWizardTab} from '@/components';

  export default {
    components: {
      GrantSubWizard,
      GrantSubWizardTab,
      Page1,
    }
  }
</script>